import axios from "axios";
import store from "@/store";
import moment from "moment";
import jwt_decode from "jwt-decode";
import VPagination from "@hennge/vue3-pagination";
import fieldRules from  "./FieldRulePopup.vue";
import uploadEditchecks from "./UploadEditchecks.vue";
import assignRuleApprover from "./AssignRuleApprover.vue";
import approveRejectModal from "../GenericApproveRejectModal/GenericApproveRejectModal.vue";


export default {
  name: "CustomFieldRules",
  components: {
    VPagination,
    fieldRules,
    uploadEditchecks,
    assignRuleApprover,
    approveRejectModal
  },
  data() {
    return {
        head: {},
        rollsprivilages:"",
        baseurl: process.env.VUE_APP_Service_URL,
        studyid: store.getters.getStudyIs,
        formid: "",
        category: "",
        approvalStatus: "",
        pageindex: 1,
        pagesize: 15,
        totalPage: 0,
        currentPage: 1,
        SortOrder: 0,
        SortProperty: "createdAt",
        customeditchecks: [],
        showTableLoading: true,
        showFieldRulePopup: false,
        selectedFieldRuleData: {},
        showUploadPopup: false,
        defaultdate: "",
        showApproveRejectPopup: false,
        selectedEditCheckPayload: {},
        approveApiEndpoint: "",
        showRuleApprover: false,
        selectedItems: new Set(),
        approvalStatuses: [],
    };
  },

  computed: {
    isAllSelected() {
      const selectable = this.customeditchecks.filter(
        (item) => !this.isFinalized(item.approvalStatus)
      );
      if (selectable.length === 0) return false;
      return selectable.every((item) => this.selectedItems.has(item.id));
    },
  },

  async mounted() {
    this.rollsprivilages = await store.getters.getRolesprivilegeData;
    const idtoken = store.getters.getIdToken;
    this.head = {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
    };

    this.defaultdate = localStorage.getItem("dateformat");

    this._studyIdChangedHandler = async (event) => {
        console.log("Study ID changed event received in CustomFieldRules component:", event.detail);
        this.studyid = store.getters.getStudyIs;

        const idtoken = store.getters.getIdToken;
        this.head = {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
        };

        this.pageindex = 1;
        this.currentPage = 1;
        this.formid = "";
        this.category = "";
        this.approvalStatus = "";

        await this.getcustomeditchecks();
    };
    window.addEventListener("studyIdChanged", this._studyIdChangedHandler);
    await this.getApprovalStatuses();
    await this.getcustomeditchecks();
  },

  beforeUnmount() {
    window.removeEventListener("studyIdChanged", this._studyIdChangedHandler);
  },

  methods: {
        isFinalized(status) {
            return status === "Approved" || status === "Rejected";
        },
        async getcustomeditchecks(){
            this.showTableLoading = true;
            this.clearSelections();
            try{
                const response = await axios.get(
                  `${this.baseurl}/custom/editcheck/getcustomeditchecks?StudyId=${this.studyid}&FormName=${this.formid}&ApprovalStatus=${this.approvalStatus}&IsActive=true&Category=${this.category}&pageindex=${this.pageindex}&pagesize=${this.pagesize}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}`,
                  this.head
                );
                this.customeditchecks = response.data.results || [];
                const totalCount = response.data.totalCount || 0;
                this.totalPage = parseInt(totalCount / this.pagesize);
                if (totalCount % this.pagesize != 0) {
                    this.totalPage = this.totalPage + 1;
                }
                this.showTableLoading = false;
                console.log("Custom Edit Checks:", response.data);
            }
            catch(error){
                console.error("Error fetching custom edit checks:", error);
                this.customeditchecks = [];
                this.showTableLoading = false;
            }
        },
        async getApprovalStatuses() {
            const statusType = "Edit Check Approval Status";
            try {
                const response = await axios.get(
                    `${this.baseurl}/management/statusmaster/getall?StatusType=${statusType}`,
                    this.head
                );
                this.approvalStatuses = response.data || [];
                console.log("Approval Statuses:", response.data);
            } catch (error) {
                console.error("Error fetching approval statuses:", error);
                this.approvalStatuses = [];
            }
        },
        loadPage: function(page) {
            this.currentPage = page;
            this.pageindex = page;
            this.getcustomeditchecks();
        },

        async search() {
            this.pageindex = 1;
            this.currentPage = 1;
            this.getcustomeditchecks();
        },

        SortSelected(sortProp, id) {
            const selectedElement = document.getElementById(id);
            const selectedElementID = document.getElementById(id).id;
            if (sortProp != null && id == selectedElementID) {
                this.sortDesc = !this.sortDesc;
                if (this.SortOrder == 0) {
                    if (selectedElement.classList.contains("sortAsc")) {
                        selectedElement.classList.remove("sortAsc");
                        selectedElement.classList.add("sortDesc");
                    } else selectedElement.classList.add("sortDesc");
                } else {
                    if (selectedElement.classList.contains("sortDesc")) {
                        selectedElement.classList.remove("sortDesc");
                        selectedElement.classList.add("sortAsc");
                    }
                    else selectedElement.classList.add("sortAsc");
                }
            }
            this.pageindex = 1;
            this.currentPage = 1;
            this.SortProperty = sortProp;
            this.SortOrder = this.SortOrder == 0 ? 1 : 0;
            this.getcustomeditchecks();
        },

        viewFieldRuleClicked(data){
            console.log("View Field Rule Clicked:", data);
            this.showFieldRulePopup = true;
            this.selectedFieldRuleData = data;
        },

        uploadEditcheckClicked(){
            this.showUploadPopup = true;
        },

        filter(data) {
            if (data) {
                return moment(data).format(this.defaultdate);
            }
        },

        closeUploadPopup(){
            this.showUploadPopup = false;
            this.getcustomeditchecks();
        },

        openApproveRejectPopup(item) {
            const logedInUser = jwt_decode(store.getters.getIdToken);
            this.approveApiEndpoint = `${this.baseurl}/management/study/approverejectcustom`;
            this.selectedEditCheckPayload = {
                approveRejectIds: [item.id], 
                studyId: item.studyId,
                formID: item.formId || "",
                fieldName: item.fieldName,
                editCheckId: item.editCheckId,
                approvedByEmail: logedInUser.email,
            };
            this.showApproveRejectPopup = true;
        },

        onApproveRejectSuccess() {
            this.showApproveRejectPopup = false;
            this.getcustomeditchecks();
        },

        clearSelections() {
            this.selectedItems = new Set();
        },

        toggleSelection(id) {
            const item = this.customeditchecks.find((r) => r.id === id);
            if (item && this.isFinalized(item.approvalStatus)) return;

            const updated = new Set(this.selectedItems);
            if (updated.has(id)) {
                updated.delete(id);
            } else {
                updated.add(id);
            }
            this.selectedItems = updated;
        },

        toggleSelectAll(event) {
            if (event.target.checked) {
                const selectableIds = this.customeditchecks
                    .filter((item) => !this.isFinalized(item.approvalStatus))
                    .map((item) => item.id);
                this.selectedItems = new Set(selectableIds);
            } else {
                this.selectedItems = new Set();
            }
        },

        async bulkRemove() {
            if (this.selectedItems.size === 0) return;

            const payload = {
                editCheckIds: Array.from(this.selectedItems),
            };

            try {
                await axios.put(
                    `${this.baseurl}/management/study/removeeditcheck`,
                    payload,
                    this.head
                );
                await this.getcustomeditchecks();
            } catch (error) {
                console.error("Bulk remove failed:", error);
            }
        },

        async bulkApprove() {
            if (this.selectedItems.size === 0) return;

            const logedInUser = jwt_decode(store.getters.getIdToken);
            const selectedIds = Array.from(this.selectedItems);

            const approveRejectCommands = this.customeditchecks
                .filter((item) => selectedIds.includes(item.id))
                .map((item) => ({
                    approveRejectIds: [item.id],
                    studyId: item.studyId,
                    formID: item.formId || "",
                    fieldName: item.fieldName,
                    editCheckId: item.editCheckId,
                    approvedByEmail: logedInUser.email,
                    status: "Approved",
                    comments: "",
                }));

            const payload = { approveRejectCommands };

            try {
                await axios.put(
                    `${this.baseurl}/management/study/approverejectmultiple`,
                    payload,
                    this.head
                );
                await this.getcustomeditchecks();
            } catch (error) {
                console.error("Bulk approve failed:", error);
            }
        },
  },
};